import { render, staticRenderFns } from "./VendorPlacementProgramModal.vue?vue&type=template&id=ddcbde0e&scoped=true&lang=pug"
import script from "./VendorPlacementProgramModal.vue?vue&type=script&lang=js"
export * from "./VendorPlacementProgramModal.vue?vue&type=script&lang=js"
import style0 from "./VendorPlacementProgramModal.vue?vue&type=style&index=0&id=ddcbde0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcbde0e",
  null
  
)

export default component.exports